import React, { useState, useContext, createContext } from 'react';

export interface SideBarContext {
  currentActiveItem?: React.MutableRefObject<unknown>;
  setCurrentActiveItem: React.Dispatch<React.SetStateAction<unknown>>;
  isCurrentActiveItem: (ref: React.MutableRefObject<unknown>) => boolean;
}

export const SideBarContext = createContext<SideBarContext | null>(null);

export const SideBarContextProvider = (props: { children: React.ReactNode }): React.ReactElement => {
  const { children } = props;

  const [currentActiveItem, setCurrentActiveItem] = useState();
  const isCurrentActiveItem = (ref: React.MutableRefObject<unknown>) => ref === currentActiveItem;

  const value = {
    currentActiveItem,
    setCurrentActiveItem,
    isCurrentActiveItem
  };

  return <SideBarContext.Provider value={value}>{children}</SideBarContext.Provider>;
};

export const useSideBarContext = (): SideBarContext => {
  const context = useContext(SideBarContext);

  if (context === null) {
    throw new Error(
      'SideBarContext must be used within a SideBarContextProvider. Most likely SideBarItem, or SideBarItemGroup are not being used as children of the SideBar parent component.'
    );
  }

  return context;
};
